'use client'

import { Page, Card, Layout, Text, BlockStack, Link, Divider, InlineStack, Box } from '@shopify/polaris'
import {
  SUPPORT_EMAIL,
  SUPPORT_PHONE_DISPLAY,
  SUPPORT_PHONE_LOCAL,
  SUPPORT_PHONE_TEL_HREF,
  SUPPORT_WHATSAPP_URL,
} from '@/lib/contact'
import { ContactForm } from './ContactForm'

export default function ContactPage() {
  return (
    <Page title="Contact" subtitle="We usually reply within one business day.">
      <Layout>
        <Layout.Section>
          <InlineStack gap="400" align="start" blockAlign="start" wrap>
            <Box width="100%" minWidth="min(100%, 320px)" maxWidth="560px" as="div">
              <Card>
                <BlockStack gap="400">
                  <BlockStack gap="100">
                    <Text as="h2" variant="headingMd">
                      Send us a message
                    </Text>
                    <Text as="p" variant="bodySm" tone="subdued">
                      Use the form and we&apos;ll respond by email. For urgent issues, call or WhatsApp.
                    </Text>
                  </BlockStack>
                  <ContactForm />
                </BlockStack>
              </Card>
            </Box>

            <Box width="100%" minWidth="min(100%, 280px)" maxWidth="420px" as="div">
              <Card>
                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    Other ways to reach us
                  </Text>
                  <BlockStack gap="300">
                    <BlockStack gap="100">
                      <Text as="span" variant="bodySm" fontWeight="semibold">
                        Email
                      </Text>
                      <Text as="p" variant="bodyMd">
                        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                      </Text>
                    </BlockStack>
                    <Divider />
                    <BlockStack gap="100">
                      <Text as="span" variant="bodySm" fontWeight="semibold">
                        Phone
                      </Text>
                      <Text as="p" variant="bodyMd">
                        <a href={SUPPORT_PHONE_TEL_HREF}>{SUPPORT_PHONE_DISPLAY}</a>
                        <Text as="span" variant="bodySm" tone="subdued">
                          {' '}
                          (Pakistan: {SUPPORT_PHONE_LOCAL})
                        </Text>
                      </Text>
                    </BlockStack>
                    <Divider />
                    <BlockStack gap="100">
                      <Text as="span" variant="bodySm" fontWeight="semibold">
                        WhatsApp
                      </Text>
                      <Text as="p" variant="bodyMd">
                        <a href={SUPPORT_WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                          Message us on WhatsApp
                        </a>
                      </Text>
                    </BlockStack>
                  </BlockStack>
                  <Divider />
                  <BlockStack gap="200">
                    <Text as="p" variant="bodySm" tone="subdued">
                      <Link url="/privacy">Privacy policy</Link>
                      {' · '}
                      <Link url="/terms">Terms of service</Link>
                    </Text>
                    <Text as="p" variant="bodySm" tone="subdued">
                      App permissions &amp; data:{' '}
                      <a href="https://help.shopify.com/en/manual/apps/app-privacy" target="_blank" rel="noopener noreferrer">
                        Shopify help article
                      </a>
                    </Text>
                  </BlockStack>
                </BlockStack>
              </Card>
            </Box>
          </InlineStack>
        </Layout.Section>
      </Layout>
    </Page>
  )
}
